
<div [class.loading-spinner]="!inline">
    <mat-progress-spinner mode="indeterminate" [diameter]="diameter"></mat-progress-spinner>
</div>